// Central content source for HashTag Marketing.
// Content and factual details ported from the agency's own site (hashtagmarketing.in).

export const VERIFY = "[CONTENT REQUIRED / VERIFY BEFORE PUBLISHING]";

export const brand = {
  name: "HashTag",
  legal: "HashTag Marketing",
  positioningShort: "Integrated brand & communications agency",
  tagline: "We find a method to your madness!",
  location: "403-Gallaria, DLF City Phase-IV, Gurgaon 122002, Haryana, India",
  city: "Gurgaon · Delhi NCR",
  yearsClaim: "15",
  yearsVerify: false,
  phone: "+91 9871130983",
  phoneHref: "tel:+919871130983",
  email: "gulnar@hashtagmarketing.in",
  whatsapp: "919871130983",
  social: {
    instagram: "https://www.instagram.com/hashtagmarketing.india/",
    linkedin: "https://www.linkedin.com/in/hashtag-marketing-a769619b/",
    facebook: "https://www.facebook.com/profile.php?id=100079482525374",
    twitter: "https://twitter.com/HashtagMkting",
  },
};

export const nav = [
  { label: "Work", to: "/work" },
  { label: "Services", to: "/services" },
  { label: "Industries", to: "/industries" },
  { label: "About", to: "/about" },
  { label: "Insights", to: "/insights" },
  { label: "Contact", to: "/contact" },
];

export const heroLines = ["We build brands", "people notice,", "remember,", "and choose."];

export const heroIntro =
  "An integrated marketing communications company on a mission to create and maintain a prominent position for your business in the right target markets, at the right time.";

export const stats = [
  { value: "15", suffix: "yrs", label: "Going strong", verify: false },
  { value: "12", suffix: "", label: "Industries served", verify: false },
  { value: "5", suffix: "", label: "Integrated capabilities", verify: false },
  { value: "100", suffix: "%", label: "Independent & founder-led", verify: false },
];

// Industries + representative client-logo ids as sourced from the agency's own client wall.
export const industries = [
  { slug: "automobiles", name: "Automobiles", blurb: "Launches, dealer activations and demand generation for auto brands.", logos: [1, 2], image: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=1400&q=75", video: "/videos/industries/automobiles.webm" },
  { slug: "beauty-wellness", name: "Beauty & Wellness", blurb: "Positioning and storytelling for beauty, skincare and wellness labels.", logos: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13], image: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?auto=format&fit=crop&w=1400&q=75", video: "/videos/industries/beauty-wellness.webm" },
  { slug: "education", name: "Education", blurb: "Admissions growth and institutional reputation for education brands.", logos: [24, 25, 26, 27, 28, 29, 30], image: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=1400&q=75", video: "/videos/industries/education.webm" },
  { slug: "entertainment-lifestyle", name: "Entertainment & Lifestyle", blurb: "Culture-first campaigns for entertainment and lifestyle.", logos: [31, 32, 33, 34, 35, 36, 37], image: "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?auto=format&fit=crop&w=1400&q=75", video: "/videos/industries/entertainment-lifestyle.webm" },
  { slug: "exhibitions", name: "Exhibitions", blurb: "Stand design, footfall and lead capture for exhibitions & fairs.", logos: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53], image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1400&q=75", video: "/videos/industries/exhibitions.webm" },
  { slug: "fashion-jewellery", name: "Fashion & Jewellery", blurb: "Editorial campaigns and launches for fashion & fine jewellery.", logos: [54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85], image: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&w=1400&q=75", video: "/videos/industries/fashion-jewellery.webm" },
  { slug: "food-beverages", name: "Food & Beverages", blurb: "Brand worlds, packaging and demand for F&B brands.", logos: [86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108], image: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=1400&q=75", video: "/videos/industries/food-beverages.webm" },
  { slug: "hospitality", name: "Hospitality", blurb: "Positioning and guest demand for hotels, restaurants and resorts.", logos: [109], image: "https://images.unsplash.com/photo-1445019980597-93fa8acb246c?auto=format&fit=crop&w=1400&q=75", video: "/videos/industries/hospitality.webm" },
  { slug: "interiors-architecture", name: "Interiors & Architecture", blurb: "Studios and product brands in design and architecture.", logos: [110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129], image: "https://images.unsplash.com/photo-1502005229762-cf1b2da7c5d6?auto=format&fit=crop&w=1400&q=75", video: "/videos/industries/interiors-architecture.webm" },
  { slug: "political", name: "Political", blurb: "Message discipline and mobilisation for political communication.", logos: [130, 131, 132], image: "https://images.unsplash.com/photo-1591189863430-ab87e120f312?auto=format&fit=crop&w=1400&q=75", video: "/videos/industries/political.webm" },
  { slug: "power", name: "Power", blurb: "Reputation and stakeholder communication for the power sector.", logos: [133, 134], image: "https://images.unsplash.com/photo-1466611653911-95081537e5b7?auto=format&fit=crop&w=1400&q=75", video: "/videos/industries/power.webm" },
  { slug: "real-estate", name: "Real Estate", blurb: "Project launches and absorption for real estate developers.", logos: [135, 136, 137, 138], image: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=1400&q=75", video: "/videos/industries/real-estate.webm" },
];

// Flat list of all client-logo indexes for logo walls / marquees.
export const clientLogos = Array.from({ length: 343 }, (_, i) => i + 1);

// Client logos extracted from the client portfolio deck, grouped by sector.
export const clientCategories = [
  { slug: "all", label: "All" },
  { slug: "food", label: "Food & Beverages" },
  { slug: "fashion-jewellery", label: "Fashion & Jewellery" },
  { slug: "beauty-wellness", label: "Beauty & Wellness" },
  { slug: "real-estate-interiors", label: "Real Estate & Interiors" },
  { slug: "events-exhibitions", label: "Events & Exhibitions" },
  { slug: "lifestyle-play", label: "Lifestyle & Play" },
  { slug: "education", label: "Education" },
  { slug: "government", label: "Government" },
];

export const clientsBySector = {
  food: [139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,161,162,163,164,165,166,167,168,169,170,171,172,173,174,175,176,177,178,179,180,181,182,183,184,185,186,187],
  "fashion-jewellery": [188,189,190,191,192,193,194,195,196,197,198,199,200,201,202,203,204,205,206,207,208,209,210,211,212,213,214,215,216,217,218,219,220,221,222,223,224,225,226,227,228,229,230,231,232],
  "beauty-wellness": [275,276,277,278,279,280,281,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,339,340,341,342,343],
  "real-estate-interiors": [243,244,245,246,247,248,249,250,251,252,253,254,255,256,257,258,259,260,261,262,263,264,265,266,267,268,269,270,271,272,273,274],
  "events-exhibitions": [299,300,301,302,303,304,305,306,307,308,309,310,311,312,313,314,315,316,317,318,319,320,321,322,323],
  "lifestyle-play": [233,234,235,236,237,238,239,240,241,242],
  education: [324,325,326,327,328,329,330,331],
  government: [332,333,334,335,336,337,338],
};


// Studio archive — original work assets ported from the legacy site (hashtagmarketing.in).
const img = (dir, n, ext = "webp") => `/images/${dir}/${n}.${ext}`;
export const workGalleries = [
  {
    id: "pr",
    title: "PR & Media Coverage",
    blurb: "Press clippings, features and earned media coverage secured for our clients.",
    images: [
      ...[1, 2, 3, 4, 5, 6, 7, 8, 9, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26].map((n) => img("pr", n)),
      ...[27, 28, 29, 30, 31].map((n) => img("pr", n, "jpeg")),
    ],
  },
  {
    id: "design",
    title: "Design & Creative",
    blurb: "Identity, packaging, social and campaign design straight from the studio.",
    images: Array.from({ length: 33 }, (_, i) => img("design", i + 1)),
  },
  {
    id: "campaigns",
    title: "Campaign Visuals",
    blurb: "Stills from campaigns, launches and shoots across categories.",
    images: [
      ...[1, 2, 3, 4, 5, 16, 17, 18, 21].map((n) => img("campaigns", n)),
      "/images/campaigns/Flyer_7.webp",
      "/images/campaigns/Magazine_ad_3.webp",
      "/images/campaigns/Standee.webp",
      "/images/campaigns/The_Bigger_Picture.webp",
      "/images/campaigns/untitled.webp",
      "/images/campaigns/malasa2.webp",
    ],
  },
  {
    id: "ads",
    title: "Print & Ads",
    blurb: "Press ads, flyers and printed collateral.",
    images: [3, 7, 10].map((n) => img("ads", n)),
  },
];

export const capabilities = [
  {
    n: "01",
    title: "Events & Activations",
    tag: "Exhibitions · Brand Activations · Conferences · Launches",
    oneLiner: "Exhibitions, brand activations, conferences and launches.",
    body: "Exhibitions, brand activations, conferences, seminars and launches. Live moments engineered to move people — and press.",
    points: [
      { label: "Exhibitions", detail: "Planning and creating exhibitions that bring your brand, products or ideas to life." },
      { label: "Brand Activations", detail: "Interactive experiences designed to create awareness, engagement and brand recall." },
      { label: "Conferences & Seminars", detail: "Planning and managing conferences, seminars and professional brand gatherings." },
      { label: "Launches", detail: "End-to-end support for product, brand, store and campaign launches." },
    ],
  },
  {
    n: "02",
    title: "Brand Management",
    tag: "Strategy · Content · Design · Engagement",
    oneLiner: "Building and managing your brand across strategy, content and communication.",
    body: "The full brand system — from positioning strategy and content to design language and audience engagement.",
    points: [
      { label: "Strategy", detail: "Brand positioning, audience insights and communication planning." },
      { label: "Content", detail: "Social media content, copywriting, storytelling and campaign content." },
      { label: "Design", detail: "Brand identity, creative assets and marketing communication design." },
      { label: "Engagement", detail: "Community management and audience interactions that build stronger relationships." },
    ],
  },
  {
    n: "03",
    title: "Digital Media",
    tag: "Social · SEM · SEO · Sales Promotion",
    oneLiner: "Driving visibility, engagement and growth across digital platforms.",
    body: "Social, search, performance and promotion — a growth engine that turns attention into qualified demand.",
    points: [
      { label: "Social Media Marketing", detail: "Content and campaigns across Instagram, Facebook and YouTube." },
      { label: "SEM", detail: "Paid advertising on Google to reach high-intent audiences." },
      { label: "SEO", detail: "Improving organic visibility and search presence on Google." },
      { label: "Sales Promotion", detail: "Digital promotions and campaigns designed to drive enquiries, conversions and sales." },
    ],
  },
  {
    n: "04",
    title: "Research & Consulting",
    tag: "Market · Competitor · Crisis",
    oneLiner: "Insights that help you understand your market and make better decisions.",
    body: "Category, competitor and crisis intelligence — the sharpest, truest picture of the world your brand competes in.",
    points: [
      { label: "Market Analysis", detail: "Research into market trends, audiences and opportunities." },
      { label: "Competitor Analysis", detail: "Understanding competitor positioning, communication and market gaps." },
      { label: "Crisis Management", detail: "Strategic communication support during reputation or business challenges." },
    ],
  },
  {
    n: "05",
    title: "Media Support & Public Relations",
    tag: "Media Relations · Coverage · Reputation",
    oneLiner: "Building visibility, credibility and a stronger digital presence through media.",
    body: "Earned reach and reputation. Media relations, story placement and communications that build credibility.",
    points: [
      { label: "Media Support", detail: "Media outreach, journalist coordination, pitching and coverage support." },
      { label: "Public Relations", detail: "PR strategy, storytelling and outreach to build brand visibility and reputation." },
      { label: "Media Relations", detail: "Building relationships with journalists, editors, publications and media houses." },
      { label: "TV & Video Interviews", detail: "Arranging relevant TV, digital video and expert interview opportunities." },
      { label: "Online Articles", detail: "Securing relevant online publication coverage and editorial mentions." },
      { label: "Newspaper Coverage", detail: "Getting brands, stories and spokespeople featured in relevant newspapers." },
      { label: "Magazine Coverage", detail: "Securing features, interviews and brand stories in relevant magazines." },
      { label: "Backlinks", detail: "Using relevant online media coverage to create opportunities for editorial backlinks." },
    ],
  },
];

export const manifesto = [
  { n: "01", title: "A method to your madness", body: "We turn scattered ambitions into a sharp, ownable brand system — a position, an idea, and the rails to run it on." },
  { n: "02", title: "Integrated, not siloed", body: "Strategy, creative, digital, PR and live experiences under one roof — one brand story, everywhere, without translation loss." },
  { n: "03", title: "Right market, right time", body: "Placement is everything. We put the right message in front of the right audience at the moment that moves them." },
  { n: "04", title: "Founder-led, hands-on", body: "You get the people whose names are on the door — not a pitch team followed by a handoff." },
];

// Featured campaigns — image sources are directly from the agency's own campaign archive.
export const work = [
  {
    slug: "tods-ss-2018",
    client: "Tod's",
    title: "Spring / Summer Campaign",
    year: "2018",
    category: "Fashion",
    services: ["Creative", "Brand Campaign"],
    image: "/images/campaigns/Tods-Spring-Summer-2018-Campaign03.webp",
    span: "lg:col-span-7",
    excerpt: "Seasonal campaign creative for the luxury house.",
  },
  {
    slug: "superdry-sport",
    client: "Superdry Sport",
    title: "Sport Line Launch",
    year: "",
    category: "Fashion & Lifestyle",
    services: ["Creative", "Retail"],
    image: "/images/campaigns/superdry_sport_.webp",
    span: "lg:col-span-5",
    excerpt: "Launch creative for the performance sport line.",
  },
  {
    slug: "zeitaku",
    client: "Zeitaku",
    title: "Brand Identity & Launch",
    year: "",
    category: "Lifestyle",
    services: ["Brand Strategy", "Creative"],
    image: "/images/campaigns/ZEITAKU_Final-01.jpg",
    span: "lg:col-span-5",
    excerpt: "Identity and launch campaign.",
  },
  {
    slug: "collagen-experience",
    client: "Collagen Experience",
    title: "Print & Experience Campaign",
    year: "",
    category: "Beauty & Wellness",
    services: ["Creative", "Experiences"],
    image: "/images/campaigns/Collagen-Experience_Print.webp",
    span: "lg:col-span-7",
    excerpt: "Print-led experience campaign for the wellness brand.",
  },
  {
    slug: "neety-singh",
    client: "Neety Singh",
    title: "Couture Campaign",
    year: "",
    category: "Fashion & Jewellery",
    services: ["Creative", "PR"],
    image: "/images/campaigns/NEETY_SINGH.webp",
    span: "lg:col-span-6",
    excerpt: "Campaign for the couture label.",
  },
  {
    slug: "nfabustone",
    client: "N’Fabustone",
    title: "Brand Campaign",
    year: "",
    category: "Interiors & Architecture",
    services: ["Creative", "Digital"],
    image: "/images/campaigns/NFabustone.webp",
    span: "lg:col-span-6",
    excerpt: "Brand campaign for the surfaces brand.",
  },
  {
    slug: "instax",
    client: "Instax",
    title: "India Launch",
    year: "",
    category: "Consumer Tech",
    services: ["Launch", "Experiences"],
    image: "/images/campaigns/instaxxx.webp",
    span: "lg:col-span-6",
    excerpt: "India launch campaign for the instant-camera brand.",
  },
  {
    slug: "malasa",
    client: "Malasa",
    title: "Brand Campaign",
    year: "",
    category: "Lifestyle",
    services: ["Creative"],
    image: "/images/campaigns/malasa.webp",
    span: "lg:col-span-6",
    excerpt: "Brand campaign visuals.",
  },
  {
    slug: "olive-bistro",
    client: "Olive Bistro",
    title: "Brand & Communications",
    year: "",
    category: "Food & Restaurant",
    services: ["PR", "Digital", "Social Media"],
    image: "/images/campaigns/olive/olive-gate.webp",
    span: "lg:col-span-12",
    excerpt: "Integrated brand, PR and digital work for the restaurant brand.",
  },
];

// NOTE: Sample placeholder narratives — replace with client-approved copy before publishing.
export const sampleCases = {
  "tods-ss-2018": {
    challenge: "Translate a global luxury house's Spring/Summer story for the Indian market without diluting the codes that make Tod's, Tod's.",
    insight: "Indian luxury buyers respond to craft narratives — provenance, hands, materials — more than seasonal trend talk.",
    strategy: "Lead with the artisanal story of the collection, adapted for editorial placements and retail touchpoints in Delhi NCR.",
    execution: "Seasonal campaign creative adapted for print and in-store, with coordinated press outreach around the collection drop.",
  },
  "superdry-sport": {
    challenge: "Launch Superdry's performance sport line in a market that knew the brand for streetwear, not athletic wear.",
    insight: "The overlap audience — style-first gym-goers — buys sportswear with the same eye they buy fashion.",
    strategy: "Position the line as 'performance you can wear out', bridging gym and street in every visual.",
    execution: "Launch creative for retail and digital, styled to keep the fashion attitude while showcasing technical features.",
  },
  zeitaku: {
    challenge: "Build a brand identity and launch platform for Zeitaku from a blank page.",
    insight: "In a crowded lifestyle market, a distinct name needs an equally distinct visual world to earn recall.",
    strategy: "Develop the identity system first, then launch with creative that lets the brand world do the talking.",
    execution: "Identity design, brand assets and a coordinated launch campaign across owned and earned channels.",
  },
  "collagen-experience": {
    challenge: "Make an ingredient-led wellness proposition tangible for consumers who had never heard of collagen rituals.",
    insight: "Wellness converts when people can feel it — education alone doesn't move category-new buyers.",
    strategy: "Pair print storytelling with a live experience so the audience could see, touch and try the product.",
    execution: "Print-led campaign supported by an experiential activation that brought the brand ritual to life.",
  },
  "neety-singh": {
    challenge: "Give a couture label a campaign presence that matched the craft of the garments.",
    insight: "Couture audiences buy the designer's point of view — the campaign had to feel authored, not produced.",
    strategy: "Editorial-style campaign imagery supported by targeted PR placement in fashion media.",
    execution: "Campaign shoot direction, creative and press outreach for the couture collection.",
  },
  nfabustone: {
    challenge: "Build brand visibility for a surfaces brand in a category where specifiers, not consumers, drive choice.",
    insight: "Architects and interior designers choose materials they've seen used beautifully — context sells surfaces.",
    strategy: "Show the material in aspirational applications and put the work in front of the design community.",
    execution: "Brand campaign creative and digital distribution aimed at the interiors and architecture audience.",
  },
  instax: {
    challenge: "Launch Instax in India and turn an analogue instant camera into a must-have for a digital-native generation.",
    insight: "The product's magic is the moment of the print appearing — an experience you have to witness live.",
    strategy: "Experience-first launch: put cameras in hands at live moments and let the prints become the media.",
    execution: "India launch campaign with on-ground experiences, creative and coordinated press coverage.",
  },
  malasa: {
    challenge: "Craft a brand campaign for Malasa that could flex across packaging, social and retail.",
    insight: "Lifestyle brands win on consistency — one distinctive visual world, applied everywhere without dilution.",
    strategy: "Build a flexible campaign toolkit from a single strong art direction.",
    execution: "Campaign visuals and brand assets produced for use across the brand's touchpoints.",
    gallery: ["/images/campaigns/malasa.webp", "/images/campaigns/malasa2.webp"],
  },
  "olive-bistro": {
    challenge: "Sharpen Olive Bistro's positioning and keep the restaurant top-of-mind in a city with a new opening every week.",
    insight: "Diners don't choose restaurants — they choose occasions. The brand had to own its occasions.",
    strategy: "Integrated brand, PR and social programme built around the bistro's signature dining moments.",
    execution: "Always-on social content, media relations and seasonal campaigns for the restaurant brand.",
    gallery: [
      "/images/campaigns/olive/olive-spread.webp",
      "/images/campaigns/olive/olive-salmon.webp",
      "/images/campaigns/olive/olive-lasagna.webp",
      "/images/campaigns/olive/olive-drink.webp",
      "/images/campaigns/olive/olive-cheers.webp",
    ],
  },
};

export function caseStudyDetail(item) {
  const s = sampleCases[item.slug] || {};
  return {
    ...item,
    sample: !!s.challenge,
    challenge: s.challenge || VERIFY,
    insight: s.insight || VERIFY,
    strategy: s.strategy || VERIFY,
    execution: s.execution || VERIFY,
    gallery: s.gallery || [],
    results: [
      { metric: VERIFY, label: "Reach" },
      { metric: VERIFY, label: "Engagement" },
      { metric: VERIFY, label: "Media coverage" },
    ],
  };
}

export const founders = [
  {
    slug: "gulnar-virk",
    name: "Gulnar Virk",
    role: "Director — HashTag Marketing",
    image: "/images/founders/gulnar-virk.webp",
    bio:
      "Called ‘Marketing Brahma’ by her team, Gulnar leads strategy, campaigns and design at HashTag. An MBA in Marketing from IBS Hyderabad, she has been part of landmark India campaigns — including the launches of Burberry and Instax in India and Prime Minister Narendra Modi’s Manthan campaign — and has curated some of the country’s most sought-after brand events.",
    quote:
      "My endeavour is to expand our clients’ horizons with strategic services of unmatched quality — because branding is a journey, not a destination.",
  },
  {
    slug: "yuvraj-singh-virk",
    name: "Yuvraj Singh Virk",
    role: "Creative Director — HashTag Marketing",
    image: "/images/founders/yuvraj-singh-virk.webp",
    bio:
      "Yuvraj leads campaign strategy, creative and content at HashTag, with over 85 startup launches to his name across digital platforms in the last seven years. He has delivered campaigns for state governments, UN organisations and global NGOs, and previously worked on Public Policy at TikTok / ByteDance, Public Affairs & Communications at Coca-Cola India & South East Asia, JWT and Hard Rock India. BSc in Banking & Finance, London School of Economics.",
    quote: "",
  },
];

// NOTE: Sample placeholder testimonials — replace with verified client quotes before publishing.
export const testimonials = [
  {
    quote:
      "HashTag doesn't just execute, they think. They walked in with a sharp point of view on our category and left us with a brand system we could actually run with.",
    name: "Marketing Head",
    company: "Luxury Fashion House",
    sample: true,
  },
  {
    quote:
      "From strategy to the last press clipping, the team behaved like an in-house partner. Integrated in the real sense. One story, everywhere.",
    name: "Founder",
    company: "D2C Beauty Brand",
    sample: true,
  },
  {
    quote:
      "Our India launch had to land in one weekend. Their campaign, PR and on-ground activation moved as one machine, and the coverage spoke for itself.",
    name: "Country Manager",
    company: "Global Consumer Tech Brand",
    sample: true,
  },
  {
    quote:
      "Founder-led, calm under pressure and unusually good at turning insight into work. That's the honest short version.",
    name: "CEO",
    company: "Real Estate Developer",
    sample: true,
  },
  {
    quote:
      "They understood the room before we did. Our positioning finally sounds like us, and it's winning us the right kind of attention.",
    name: "Director",
    company: "Fine Jewellery Label",
    sample: true,
  },
  {
    quote:
      "Best editorial and PR craft we've worked with in a long time. Every deliverable felt considered, never templated.",
    name: "Brand Lead",
    company: "Hospitality Group",
    sample: true,
  },
];

export const insights = [
  {
    slug: "why-integrated-beats-siloed",
    title: "Why integrated beats siloed for modern Indian brands",
    category: "Brand Strategy",
    read: "6 min",
    author: "HashTag Marketing",
    date: "March 2025",
    image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?auto=format&fit=crop&w=1600&q=80",
    dek: "When strategy, creative, PR and experiences report to different partners, the brand pays a quiet translation tax. Here is how integration compounds instead.",
    excerpt: "When strategy, creative, PR and experiences report to different partners, the brand pays the translation tax. Here is how integration compounds.",
    body: [
      { type: "p", text: "Most brands do not have a creativity problem. They have a coordination problem. The strategy lives with one partner, the campaign with another, PR with a third, and the launch event with a fourth. Each is competent. None of them share a brief, a calendar, or a definition of success." },
      { type: "p", text: "The result is a brand that says slightly different things in slightly different rooms. Not wrong, just misaligned. And misalignment is expensive in a way that never shows up on an invoice." },
      { type: "h2", text: "The translation tax" },
      { type: "p", text: "Every handoff between agencies is a translation. The strategy deck becomes a creative brief, which becomes a media plan, which becomes a press note, which becomes an event run sheet. At each step, a little intent leaks out. By the time the work reaches the audience, the sharp idea you started with has been rounded off four times." },
      { type: "p", text: "You feel the tax as slower approvals, duplicated research, and campaigns that look like they were built by committee, because they were." },
      { type: "quote", text: "A brand does not experience your org chart. It experiences the gaps between it." },
      { type: "h2", text: "What integration actually changes" },
      { type: "p", text: "When strategy, content, design, digital, PR and experiences sit in one team, the brief is written once and carried all the way through. The person who set the positioning is in the room when the launch film is cut and when the journalist is briefed. Nothing gets re-explained, so nothing gets diluted." },
      { type: "list", items: [
        "One narrative, expressed natively on every surface instead of translated onto it.",
        "Faster decisions, because context does not have to be rebuilt for each partner.",
        "Compounding assets, where a launch feeds content, content feeds PR, and PR feeds the next campaign.",
      ] },
      { type: "h2", text: "Integration is a discipline, not a department" },
      { type: "p", text: "Putting everyone under one roof is the easy part. The discipline is refusing to let the channels drift once the pressure is on. That means a single source of truth for the brand, shared success metrics across teams, and a willingness to kill a good idea that does not fit the story." },
      { type: "p", text: "Done well, integration stops feeling like efficiency and starts feeling like momentum. Every piece of work makes the next one easier, cheaper and louder. That is the whole point of building a brand rather than renting attention." },
    ],
  },
  {
    slug: "launching-a-brand-in-india",
    title: "The anatomy of a brand launch that actually lands",
    category: "Launches",
    read: "7 min",
    author: "HashTag Marketing",
    date: "January 2025",
    image: "https://images.unsplash.com/flagged/photo-1590425113058-3a2678b4cdad?auto=format&fit=crop&w=1600&q=80",
    dek: "A launch is not an event. It is a sequence. What has to be true before, during and after day one for attention to convert into demand.",
    excerpt: "A launch is not an event — it is a sequence. What has to be true before, during and after day one for a launch to convert attention into demand.",
    body: [
      { type: "p", text: "Founders love launch day. It is the fireworks, the stage, the coverage. But the brands that break through treat launch day as the middle of the story, not the beginning. The work that decides the outcome happens on either side of it." },
      { type: "h2", text: "Before: earn the right to be noticed" },
      { type: "p", text: "The weeks before a launch are for building tension, not spending it. That means seeding the story with a small circle of the right people, getting the product genuinely ready, and deciding the single sentence you want the market to repeat. If you cannot say what the brand is in one line, the audience will write that line for you, and they will get it wrong." },
      { type: "quote", text: "Attention is easy to buy for a day. The job is to be worth remembering on day thirty." },
      { type: "h2", text: "During: concentrate the signal" },
      { type: "p", text: "Day one is about concentration. Everything the brand does should point at the same idea within the same window, so the noise stacks instead of scattering. Paid media, PR, founder voice, creators and the launch moment itself should all land close together. A launch that trickles out over a month rarely reaches escape velocity." },
      { type: "list", items: [
        "One message, carried across every channel on the same days.",
        "A moment worth documenting, so audiences and media do the amplification for you.",
        "A clear next step, so the curious can act while the interest is hot.",
      ] },
      { type: "h2", text: "After: convert the curiosity" },
      { type: "p", text: "The most wasted asset in Indian marketing is the week after a launch. Interest is at its peak and most brands go quiet. This is exactly when you should be answering questions, publishing proof, following up with everyone who leaned in, and turning launch content into an always-on story." },
      { type: "p", text: "A launch is not a firework. It is the first turn of a flywheel. Judge it not by the applause on day one, but by how much easier it makes the second campaign, the second round of press, and the second cohort of customers." },
    ],
  },
  {
    slug: "experiential-marketing-that-earns-media",
    title: "Designing experiences that earn media, not just footfall",
    category: "Experiential",
    read: "5 min",
    author: "HashTag Marketing",
    date: "November 2024",
    image: "https://images.unsplash.com/photo-1778507936181-c8022255f42b?auto=format&fit=crop&w=1600&q=80",
    dek: "The best activations are built to be filmed, shared and reported. A simple framework for turning a physical moment into earned reach.",
    excerpt: "The best activations are built to be filmed, shared and reported. A framework for turning a physical moment into earned reach.",
    body: [
      { type: "p", text: "An activation that only reaches the people standing in front of it is a very expensive way to talk to a small crowd. The activations worth doing are the ones designed, from the first sketch, to travel far beyond the room." },
      { type: "h2", text: "Design for the second audience" },
      { type: "p", text: "Every experience has two audiences. The first is physically present. The second, far larger, meets it through a phone screen, a reel or a news story. If you only design for the first, you leave most of the value on the table. If you design for the second, the first still has a great time." },
      { type: "quote", text: "If a moment is not worth filming, it is not worth building." },
      { type: "h2", text: "Build in the reason to share" },
      { type: "p", text: "Shareability is not luck. It is engineered. A strong activation gives people a clear reason to pull out their phone: a spectacle they have not seen, a moment that makes them look good for posting it, or a story a journalist can tell in one headline." },
      { type: "list", items: [
        "A hero visual that reads instantly, even as a thumbnail.",
        "A human moment, because people share people, not logos.",
        "A tight narrative a reporter can file without having to invent the angle.",
      ] },
      { type: "h2", text: "Plan the afterlife, not just the day" },
      { type: "p", text: "Treat the live moment as a shoot as much as an event. Capture it properly, cut it fast, and have the media story ready to go while the moment is still warm. The footfall lasts an evening. The footage, if you plan for it, can work for months." },
      { type: "p", text: "The best experiential work does not choose between presence and reach. It uses the first to manufacture the second." },
    ],
  },
  {
    slug: "pr-for-startups",
    title: "PR for startups: credibility before you can buy it",
    category: "PR & Communications",
    read: "6 min",
    author: "HashTag Marketing",
    date: "September 2024",
    image: "https://images.unsplash.com/photo-1498644035638-2c3357894b10?auto=format&fit=crop&w=1600&q=80",
    dek: "Early-stage brands cannot out-spend incumbents. They can out-narrate them. How founders should think about earned influence.",
    excerpt: "Early-stage brands cannot out-spend incumbents. They can out-narrate them. How founders should think about earned influence.",
    body: [
      { type: "p", text: "For a young brand, PR is often misread as a logo hunt: get the name into a few publications and hope some credibility rubs off. That version of PR rarely moves anything, because coverage without a story is just noise with a masthead attached." },
      { type: "h2", text: "You cannot buy trust, but you can earn it" },
      { type: "p", text: "Incumbents can outspend you on every channel that money can rent. What they cannot easily buy is a fresh, credible point of view. That is the one place a startup starts even, and often ahead. Earned influence is the compounding interest of a young brand." },
      { type: "quote", text: "Startups cannot out-spend the incumbents. They can out-narrate them." },
      { type: "h2", text: "Lead with a point of view, not a press release" },
      { type: "p", text: "Journalists do not need your product update. They need a story their readers care about, and a credible person to tell it. The founders who earn coverage are the ones with a clear stance on where their category is going, backed by something only they can see from where they sit." },
      { type: "list", items: [
        "A sharp opinion on your category, not a description of your features.",
        "Proof you can point to: data, a customer, a result, a shift you spotted early.",
        "A spokesperson who sounds like a human, not a brochure.",
      ] },
      { type: "h2", text: "Play the long relationship, not the one hit" },
      { type: "p", text: "PR compounds when you treat journalists as a long relationship rather than a one-time favour. Be useful when you are not pitching. Be reachable and honest when a story breaks. Over time, you stop chasing coverage and start being the call a reporter makes when your category is in the news." },
      { type: "p", text: "Credibility built this way is slow, and that is the point. It is hard to buy, hard to fake, and very hard for a better-funded rival to take away." },
    ],
  },
];

